import React from "react"
import ReactDOM from "react-dom/client"
import "assets/css/tailwind.scss"
import "assets/css/main.scss"
import "assets/css/chartjs-custom-elements.scss"
import "assets/css/bootstrap-icons.css"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import App from "./App"
import "config/i18n"
import "swiper/css"
import "swiper/css/zoom"
import "swiper/css/pagination"
import "swiper/css/navigation"

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
)
